import { React, useRef, useState } from "react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
const CompletionTrendGraphNew = (props) => {

    const ref = useRef(null)
    const {
        crsCompltTrendData, completionTrendLabel, textLabel,
        crsCompTrendKeys, crsCompltTrend, setTrendYear,
        trendYear, setImgLoader, setLoaderChart, loaderChart
    } = props;
    const [trendData, setTrendData] = useState(true)
    const [trendValue, setTrendValue] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])

    var options = {
        colors: ["#0FB41C", "#28C76F"],
        chart: {
            type: "scatter",
            height: 200,
            width: 900,
            zoom: {
                enabled: false,
                type: "xy",
            },
            toolbar: {
                show: false,
            },
        },
        responsive: [
            {
                breakpoint: 1600,
                options: {
                    chart: {
                        width: 680,
                        height: 200,
                    },
                },
            },
            {
                breakpoint: 1356,
                options: {
                    chart: {
                        width: 600,
                        height: 150,
                    },
                },
            },
            {
                breakpoint: 1200,
                options: {
                    chart: {
                        width: 500,
                        height: 150,
                    },
                },
            },
            {
                breakpoint: 992,
                options: {
                    chart: {
                        width: 500,
                        height: 150,
                    },
                },
            },
            {
                breakpoint: 500,
                options: {
                    chart: {
                        width: 290,
                        height: 200,
                    },
                },
            },
        ],
        series: [
            // { name: completionTrendLabel, data: crsCompltTrendData }
            {
                name: "Series 1",
                data: [
                    {
                        x: "Jan",
                        y: crsCompltTrendData[0],
                    },
                    {
                        x: "Feb",
                        y: crsCompltTrendData[1],
                    },
                    {
                        x: "Mar",
                        y: crsCompltTrendData[2],
                    },
                    {
                        x: "Apr",
                        y: crsCompltTrendData[3],
                    },
                    {
                        x: "May",
                        y: crsCompltTrendData[4],
                    },
                    {
                        x: "Jun",
                        y: crsCompltTrendData[5],
                    },
                    {
                        x: "Jul",
                        y: crsCompltTrendData[6],
                    },
                    {
                        x: "Aug",
                        y: crsCompltTrendData[7],
                    },
                    {
                        x: "Sep",
                        y: crsCompltTrendData[8],
                    },
                    {
                        x: "Oct",
                        y: crsCompltTrendData[9],
                    },
                    {
                        x: "Nov",
                        y: crsCompltTrendData[10],
                    },
                    {
                        x: "Dec",
                        y: crsCompltTrendData[11],
                    },


                ]
            }
        ],
        xaxis: {
            type: "category",
            categories: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            // categories: crsCompTrendKeys,
            labels: {
                formatter: function (value, timestamp, index) {
                    // console.log(value)
                    return [value];
                },
                style: {
                    fontSize: "10px",
                },
            },
            tickAmount: 12,
            tickPlacement: "between",
        },
        yaxis: {
            show: true,
            // min: 0,
            // max: 100,
            // tickAmount: 4,
            showAlways: true,
            categories: crsCompltTrendData,
            // categories: crsCompTrendKeys,
            labels: {
                formatter: function (value, timestamp, index) {
                    // console.log(value)
                    return [value];
                },
                style: {
                    fontSize: "10px",
                },
            },
            title: {
                text: textLabel ? textLabel : "Agents Completed",
            },
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

                return '<div style="padding: 10px;"><b>' + data.y + '</b></div>';
            }
        },
        markers: {
            strokeWidth: 0,
        },
        legend: {
            height: 30,
        },
    };

    useEffect(() => {
        console.log('crsCompltTrendData: ', crsCompltTrendData)
        setTrendValue(crsCompltTrendData)
    }, [crsCompltTrendData])



    useEffect(() => {
        // if (trendData) {
        //   setTrendData(!trendData)
        //var chart = new ApexCharts(document.querySelector(".chartapx"), options);
        console.log('RENDER CHART')
        var chart = new ApexCharts(ref.current, options);
        chart.render();
        // }
    }, []);

    // useEffect(() => {
    //   onChangeHandlerForm()
    // }, [trendYear])
    // const onChangeHandlerForm = (e) => {
    //   setTrendYear(e.target.value)
    //   console.log("selctd Year", trendYear)
    // }
    // console.log("selctd Year", trendYear)
    return (
        <>
            {/* <span>
        <b>
          Completion
          <br /> Trend
        </b>
      </span> */}
            <div className="chartfilterbox-rsp">
                {/* <div className="input-text fliterreportsgen graphselct">
          <label for="filter" className="input__label">Select Year</label>
          <select type="text" id="filter" name="filter" className="form-select input_searchfield mb-0 session-filter"
            onChange={(e) => {
              const selectedYear = e.target.value;
              setTrendYear(selectedYear)
              setImgLoader(true)             
            }}
          >
            {crsCompltTrend?.map((item, index) => {
              return (
                <option seleted key={index} value={item[index]}
                >{item}</option>
              )
            })}            
          </select>
        </div> */}
                <div ref={ref} id="chartapx" className="chartapx pl-2">
                </div>
            </div>
        </>
    );
}

export default CompletionTrendGraphNew